<template>
  <v-container fluid>
    <v-row class="mb-6">
      <v-col cols="12" align="center">
        <a @click="clearAddress" class="blue--text text--darken-4">
          <v-btn large icon class="text-center" color="blue darken-2">
            <v-icon class>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>Change address
        </a>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" align="center">
        <h4 class="text-h4 blue--text text--darken-4 text-center">
          We offer these services at
          <strong>{{ address.address }}, {{ city.name }}, IL</strong>:
        </h4>
      </v-col>
    </v-row>
    <v-row class="mt-8 mx-4" align="center" justify="center">
      <v-col v-for="(service, key) in filteredServiceOffers" :key="key" style="max-width: 33%">
        <ServiceCard :service="service" />
      </v-col>
    </v-row>
    <v-row class="mt-12">
      <v-col>
        <h4 class="text-h4 text-center blue--text text--darken-4">
          Call our friendly, local support at
          <strong>618.939.6112</strong> to
          sign up today!
        </h4>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ServiceCard from "./ServiceCard.vue";
export default {
  components: { ServiceCard },
  name: "Services",

  props: ["address", "city", "business"],

  mounted() {
    this.fetchServiceOffers();
  },

  data: () => ({
    serviceOffers: []
  }),

  methods: {
    clearAddress() {
      this.$emit("clearAddress");
    },
    fetchServiceOffers() {
      this.$axios
        .get("/api/service-addresses/" + this.address.id)
        .then(({ data }) => {
          this.serviceOffers = data.serviceOffers;
        })
        .catch(() => {
          this.serviceOffers = [];
        })
        .then(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    maxInternetPackage() {
      if (this.serviceOffers && this.serviceOffers.length > 0) {
        let serviceOffers = this.serviceOffers.filter(x => {
          return x.service_type === "internet" && this.business == x.business;
        });
        if (serviceOffers.length) {
          return serviceOffers.reduce((prev, current) =>
            prev.download_mbps > current.download_mbps ? prev : current
          );
        }
        return null;
      }
      return null;
    },
    filteredServiceOffers() {
      if (this.serviceOffers && this.serviceOffers.length > 0) {
        let serviceOffers = this.serviceOffers.filter(x => {
          return x.name !== "IPTV" && x.service_type !== "internet";
        });
        if (this.maxInternetPackage) {
          serviceOffers.unshift(this.maxInternetPackage);
        }
        return serviceOffers;
      }
      return [];
    }
  }
};
</script>
